<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-skeleton-loader
      :loading="isLoading"
      transition="scale-transition"
      type="table"
      class="mx-auto"
    >
      <div>
        <v-row>
          <v-col cols="12" sm="12">
            <p class="text-xl font-medium">1. Cài đặt chung</p>
            <v-divider></v-divider>
            <v-row class="mt-3 mb-3">
              <v-col cols="7" sm="3">
                <p class="mt-4">Số ngày cảnh báo thiết bị</p>
              </v-col>
              <v-col cols="5" sm="3">
                <v-text-field v-model="dayWarning" outlined color="#FBB040" clearable />
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="mt-3 mb-3">
              <v-col cols="7" sm="3">
                <p class="mt-4">Số ngày cảnh báo sim</p>
              </v-col>
              <v-col cols="5" sm="3">
                <v-text-field
                  v-model="dayWarningSim"
                  outlined
                  color="#FBB040"
                  clearable
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="12" sm="6">
            <v-btn
              @click="onUpdate"
              x-large
              color="#FBB040"
              class="text-white"
              button
              dark
              ><v-icon right dark class="mr-2"> mdi-folder-plus </v-icon>
              Cập nhật
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import DatePicker from "~/components/atoms/DatePicker.vue";

export default {
  name: "PatientList",
  components: { DatePicker },
  data() {
    return {
      list: [],
      isLoading: false,
      dayWarning: 0,
      dayWarningSim: 0,
    };
  },
  async created() {
    await this.getData();
  },
  watch: {
    "$route.query": {
      async handler() {
        if (!Object.keys(this.$route.query).length) {
          this.options = { page: 1, itemsPerPage: 5 };
        }
        await this.getData();
      },
      deep: true,
    },
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const data = await this.$services.settingService.getSetting();
        this.dayWarning = data?.checkSimDay;
        this.dayWarningSim = data?.checkSimExperiedDay;
      } catch (err) {
      } finally {
        this.isLoading = false;
      }
    },
    async onUpdate() {
      this.isLoading = true;
      try {
        const data = await this.$services.settingService.updateSetting({
          checkSimDay: this.dayWarning,
          checkSimExperiedDay: this.dayWarningSim,
        });
        this.dayWarning = data?.checkSimDay;
        this.dayWarningSim = data?.checkSimExperiedDay;
      } catch (err) {
      } finally {
        this.$router.go();
        this.isLoading = false;
      }
    },
  },
};
</script>
